/* eslint-disable fp/no-delete */
/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/scandipwa
 * @link https://github.com/scandipwa/scandipwa
 */

import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import { connect } from 'react-redux';

import ProductAlertsQuery from 'Query/ProductAlerts.query';
import { goToPreviousNavigationState } from 'Store/Navigation/Navigation.action';
import { TOP_NAVIGATION_TYPE } from 'Store/Navigation/Navigation.reducer';
import { showNotification } from 'Store/Notification/Notification.action';
import { hideActiveOverlay } from 'Store/Overlay/Overlay.action';
import transformToNameValuePair from 'Util/Form/Transform';
import { fetchMutation } from 'Util/Request';

import FormMondlyPopup from './FormMondlyPopup.component';
import { FORM_MONDLY_POPUP_ID } from './FormMondlyPopup.config';
/** @namespace Bookland/Component/FormMondlyPopup/Container/mapDispatchToProps */
export const mapDispatchToProps = (dispatch) => ({
    showError: (message) => dispatch(showNotification('error', message)),
    showNotification: (type, message) => dispatch(showNotification(type, message)),
    showErrorNotification: (message) => dispatch(showNotification('error', message)),
    hideActiveOverlay: () => dispatch(hideActiveOverlay()),
    goToPreviousHeaderState: () => dispatch(goToPreviousNavigationState(TOP_NAVIGATION_TYPE))
});

/** @namespace Bookland/Component/FormMondlyPopup/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    email: state.CheckoutReducer.email,
    payload: state.PopupReducer.popupPayload[FORM_MONDLY_POPUP_ID] || {}
});

/** @namespace Bookland/Component/FormMondlyPopup/Container */
export class FormMondlyPopupContainer extends PureComponent {
    static propTypes = {
        hideActiveOverlay: PropTypes.func.isRequired,
        showErrorNotification: PropTypes.func.isRequired,
        showNotification: PropTypes.func.isRequired,
        goToPreviousHeaderState: PropTypes.func.isRequired,
        handleFormMondly: PropTypes.func.isRequired
    };

    state = {
        isLoading: false
    };

    __construct(props) {
        super.__construct(props);
    }

    containerProps() {
        const { isLoading } = this.state;

        return {
            isLoading
        };
    }

    async handleFormMondly(input) {
        const {
            showErrorNotification,
            showNotification,
            hideActiveOverlay,
            goToPreviousHeaderState
        } = this.props;

        const query = ProductAlertsQuery.getFormMondly({
            ...input
        });

        this.setState({
            isLoading: true
        });

        try {
            await fetchMutation(query);

            showNotification('success', __('Your form was sent.'));
        } catch (error) {
            const message = error?.[0]?.message;

            showErrorNotification(message);
        }

        this.setState({
            isLoading: false
        });

        document.getElementById('FormMondly').children[1].reset();

        goToPreviousHeaderState();
        hideActiveOverlay();
    }

    handleSubmitForm = (_event, fields) => {
        const input = transformToNameValuePair(fields);

        this.handleFormMondly(input);
    };

    render() {
        return (
            <FormMondlyPopup
              { ...this.containerProps() }
              submitForm={ this.handleSubmitForm }
            />
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(FormMondlyPopupContainer);
